// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deposit / transaction history — same shell as withdrawal & All Users */
.lp-deposit-history {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 1rem;
}

.lp-deposit-history .lp-deposit-card {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.lp-deposit-history .lp-deposit-card .card-body {
  color: #0f172a;
}

.lp-deposit-history .lp-deposit-title {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin-bottom: 0.75rem;
}

.lp-deposit-history .lp-deposit-title-icon {
  display: inline-flex;
  color: #4f46e5;
  flex-shrink: 0;
}

.lp-deposit-history .lp-deposit-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
}

.lp-deposit-history .lp-deposit-filters .form-control {
  border-radius: 8px;
  border-color: #e2e8f0;
  font-size: 0.8125rem;
  min-height: 36px;
}

.lp-deposit-history .lp-deposit-filter-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.lp-deposit-history .lp-deposit-filter-pills .btn {
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.3rem 0.65rem;
}

.lp-deposit-history .lp-deposit-table-wrap {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  overflow: auto;
  max-height: min(70vh, 560px);
  -webkit-overflow-scrolling: touch;
  background: #fff;
}

.lp-deposit-history .table {
  margin-bottom: 0;
  font-size: 0.8125rem;
  color: #334155;
}

.lp-deposit-history .table thead th {
  background: #f1f5f9;
  color: #475569;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.lp-deposit-history .table tbody td {
  border-color: #f1f5f9;
  vertical-align: middle;
}

.lp-deposit-history .table tbody tr:hover {
  background: #f8fafc;
}

.lp-deposit-history .lp-deposit-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.lp-deposit-history .lp-deposit-actions .btn {
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 600;
  width: auto;
  flex: 0 0 auto;
  min-width: 0;
  padding: 0.3rem 0.5rem;
  white-space: nowrap;
}

.lp-deposit-history .table thead th:last-child,
.lp-deposit-history .table tbody td:last-child {
  min-width: 12.5rem;
  white-space: nowrap;
}

.lp-deposit-history .lp-avatar {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, #e0f2fe, #bae6fd);
  color: #0369a1;
}

.lp-deposit-history .lp-deposit-user-link {
  color: #0f172a;
}

.lp-deposit-history .pagination .page-link {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-card {
  background: linear-gradient(180deg, #141820 0%, #0f1218 100%);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-card .card-body {
  color: #e4e4e7;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-title {
  color: #f4f4f5;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-title-icon {
  color: #a5b4fc;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-table-wrap {
  background: #0c0f14;
  border-color: rgba(255, 255, 255, 0.08);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table {
  color: #e4e4e7;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table thead th {
  background: rgba(255, 255, 255, 0.06);
  color: #a1a1aa;
  border-color: rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table tbody td {
  border-color: rgba(255, 255, 255, 0.06);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table tbody tr:hover {
  background: rgba(255, 255, 255, 0.04);
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .form-control {
  background: rgba(15, 18, 24, 0.9);
  border-color: rgba(255, 255, 255, 0.12);
  color: #f4f4f5;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-avatar {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.25), rgba(14, 165, 233, 0.2));
  color: #7dd3fc;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-user-link {
  color: #f4f4f5 !important;
}

.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-user-link .text-muted {
  color: #a1a1aa !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/transaction/Transactionhistory.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Deposit / transaction history — same shell as withdrawal & All Users */\n.lp-deposit-history {\n  max-width: 1080px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 1rem;\n}\n\n.lp-deposit-history .lp-deposit-card {\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.lp-deposit-history .lp-deposit-card .card-body {\n  color: #0f172a;\n}\n\n.lp-deposit-history .lp-deposit-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  margin-bottom: 0.75rem;\n}\n\n.lp-deposit-history .lp-deposit-title-icon {\n  display: inline-flex;\n  color: #4f46e5;\n  flex-shrink: 0;\n}\n\n.lp-deposit-history .lp-deposit-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.lp-deposit-history .lp-deposit-filters .form-control {\n  border-radius: 8px;\n  border-color: #e2e8f0;\n  font-size: 0.8125rem;\n  min-height: 36px;\n}\n\n.lp-deposit-history .lp-deposit-filter-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.lp-deposit-history .lp-deposit-filter-pills .btn {\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.3rem 0.65rem;\n}\n\n.lp-deposit-history .lp-deposit-table-wrap {\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  overflow: auto;\n  max-height: min(70vh, 560px);\n  -webkit-overflow-scrolling: touch;\n  background: #fff;\n}\n\n.lp-deposit-history .table {\n  margin-bottom: 0;\n  font-size: 0.8125rem;\n  color: #334155;\n}\n\n.lp-deposit-history .table thead th {\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.lp-deposit-history .table tbody td {\n  border-color: #f1f5f9;\n  vertical-align: middle;\n}\n\n.lp-deposit-history .table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.lp-deposit-history .lp-deposit-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.lp-deposit-history .lp-deposit-actions .btn {\n  border-radius: 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  width: auto;\n  flex: 0 0 auto;\n  min-width: 0;\n  padding: 0.3rem 0.5rem;\n  white-space: nowrap;\n}\n\n.lp-deposit-history .table thead th:last-child,\n.lp-deposit-history .table tbody td:last-child {\n  min-width: 12.5rem;\n  white-space: nowrap;\n}\n\n.lp-deposit-history .lp-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #e0f2fe, #bae6fd);\n  color: #0369a1;\n}\n\n.lp-deposit-history .lp-deposit-user-link {\n  color: #0f172a;\n}\n\n.lp-deposit-history .pagination .page-link {\n  font-size: 0.75rem;\n  padding: 0.25rem 0.5rem;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-card {\n  background: linear-gradient(180deg, #141820 0%, #0f1218 100%);\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-card .card-body {\n  color: #e4e4e7;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-title {\n  color: #f4f4f5;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-title-icon {\n  color: #a5b4fc;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-table-wrap {\n  background: #0c0f14;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table {\n  color: #e4e4e7;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table thead th {\n  background: rgba(255, 255, 255, 0.06);\n  color: #a1a1aa;\n  border-color: rgba(255, 255, 255, 0.06);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table tbody td {\n  border-color: rgba(255, 255, 255, 0.06);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .form-control {\n  background: rgba(15, 18, 24, 0.9);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #f4f4f5;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-avatar {\n  background: linear-gradient(135deg, rgba(56, 189, 248, 0.25), rgba(14, 165, 233, 0.2));\n  color: #7dd3fc;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-user-link {\n  color: #f4f4f5 !important;\n}\n\n.admin-app.admin-theme-v2:not(.admin-theme-light) .lp-deposit-history .lp-deposit-user-link .text-muted {\n  color: #a1a1aa !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
